// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/order.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse, SortSpec } from "./common_pb.js";
import { ConfigOption, MatchMode } from "./work_item_pb.js";

/**
 * @generated from message omnios.v1.SalesOrder
 */
export const SalesOrder = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SalesOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seq_no", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "delivery", kind: "message", T: Struct },
    { no: 10, name: "payment", kind: "message", T: Struct },
    { no: 11, name: "attrs", kind: "message", T: Struct },
    { no: 17, name: "source_quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "status_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "status_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "status_entered_at", kind: "message", T: Timestamp },
    { no: 16, name: "status_sla_deadline", kind: "message", T: Timestamp },
    { no: 20, name: "lines", kind: "message", T: OrderLine, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.OrderLine
 */
export const OrderLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.OrderLine",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "discount_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "attrs", kind: "message", T: Struct },
    { no: 11, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateOrderRequest
 */
export const CreateOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateOrderRequest",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "delivery", kind: "message", T: Struct },
    { no: 7, name: "payment", kind: "message", T: Struct },
    { no: 8, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.GetOrderRequest
 */
export const GetOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateOrderRequest
 */
export const UpdateOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "delivery", kind: "message", T: Struct },
    { no: 7, name: "payment", kind: "message", T: Struct },
    { no: 8, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeleteOrderRequest
 */
export const DeleteOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListOrdersRequest
 */
export const ListOrdersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrdersRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "source_quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListOrdersResponse
 */
export const ListOrdersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrdersResponse",
  () => [
    { no: 1, name: "orders", kind: "message", T: SalesOrder, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.AddOrderLineRequest
 */
export const AddOrderLineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddOrderLineRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "discount_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdateOrderLineRequest
 */
export const UpdateOrderLineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateOrderLineRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 3, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "discount_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.RemoveOrderLineRequest
 */
export const RemoveOrderLineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemoveOrderLineRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.FinalizePurchaseOrderRequest
 */
export const FinalizePurchaseOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizePurchaseOrderRequest",
  () => [
    { no: 1, name: "case_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.FinalizePurchaseOrderResponse
 */
export const FinalizePurchaseOrderResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizePurchaseOrderResponse",
  () => [
    { no: 1, name: "order", kind: "message", T: SalesOrder },
    { no: 2, name: "lines_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ProcessPurchaseOrderRequest
 */
export const ProcessPurchaseOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProcessPurchaseOrderRequest",
  () => [
    { no: 1, name: "case_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mode", kind: "enum", T: proto3.getEnumType(MatchMode) },
  ],
);

/**
 * @generated from message omnios.v1.PurchaseOrderReview
 */
export const PurchaseOrderReview = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PurchaseOrderReview",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "case_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "raw_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "matched_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "matched_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "parsed_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "parsed_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "selling_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "converted_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "attrs", kind: "message", T: Struct },
    { no: 16, name: "reject_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListOrderReviewsRequest
 */
export const ListOrderReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrderReviewsRequest",
  () => [
    { no: 1, name: "case_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "triage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListOrderReviewsResponse
 */
export const ListOrderReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrderReviewsResponse",
  () => [
    { no: 1, name: "reviews", kind: "message", T: PurchaseOrderReview, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ReviewOrderReviewRequest
 */
export const ReviewOrderReviewRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewOrderReviewRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "matched_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ReviewOrderReviewResponse
 */
export const ReviewOrderReviewResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewOrderReviewResponse",
  () => [
    { no: 1, name: "review", kind: "message", T: PurchaseOrderReview },
  ],
);

/**
 * @generated from message omnios.v1.BatchReviewOrderReviewsRequest
 */
export const BatchReviewOrderReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReviewOrderReviewsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchReviewOrderReviewsResponse
 */
export const BatchReviewOrderReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReviewOrderReviewsResponse",
  () => [
    { no: 1, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchResearchOrderReviewsRequest
 */
export const BatchResearchOrderReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchResearchOrderReviewsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BatchResearchOrderReviewsResponse
 */
export const BatchResearchOrderReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchResearchOrderReviewsResponse",
  () => [
    { no: 1, name: "researched", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchOrderReviewAlternativesRequest
 */
export const SearchOrderReviewAlternativesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchOrderReviewAlternativesRequest",
  () => [
    { no: 1, name: "review_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "query_override", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "attribute_filters", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "category_filter", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "include_facets", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkDeleteOrdersRequest
 */
export const BulkDeleteOrdersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkDeleteOrdersRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "all", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkDeleteOrdersResponse
 */
export const BulkDeleteOrdersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkDeleteOrdersResponse",
  () => [
    { no: 1, name: "deleted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.TransitionOrderStatusRequest
 */
export const TransitionOrderStatusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TransitionOrderStatusRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.TransitionOrderStatusResponse
 */
export const TransitionOrderStatusResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TransitionOrderStatusResponse",
  () => [
    { no: 1, name: "order", kind: "message", T: SalesOrder },
    { no: 2, name: "allowed_next_statuses", kind: "message", T: ConfigOption, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetOrderStatusOptionsRequest
 */
export const GetOrderStatusOptionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOrderStatusOptionsRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetOrderStatusOptionsResponse
 */
export const GetOrderStatusOptionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOrderStatusOptionsResponse",
  () => [
    { no: 1, name: "current_status", kind: "message", T: ConfigOption },
    { no: 2, name: "allowed_transitions", kind: "message", T: ConfigOption, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AddOrderCommentRequest
 */
export const AddOrderCommentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddOrderCommentRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetOrderAnalyticsRequest
 */
export const GetOrderAnalyticsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOrderAnalyticsRequest",
  () => [
    { no: 1, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetOrderAnalyticsResponse
 */
export const GetOrderAnalyticsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOrderAnalyticsResponse",
  () => [
    { no: 1, name: "daily_stats", kind: "message", T: OrderDailyStats, repeated: true },
    { no: 2, name: "summary", kind: "message", T: OrderSummaryStats },
  ],
);

/**
 * @generated from message omnios.v1.OrderDailyStats
 */
export const OrderDailyStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.OrderDailyStats",
  () => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "revenue_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "avg_order_value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "unique_customers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.OrderSummaryStats
 */
export const OrderSummaryStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.OrderSummaryStats",
  () => [
    { no: 1, name: "total_orders", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_revenue_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "avg_order_value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "avg_fulfillment_hours", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.ListOrderStatusOptionsRequest
 */
export const ListOrderStatusOptionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrderStatusOptionsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListOrderStatusOptionsResponse
 */
export const ListOrderStatusOptionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrderStatusOptionsResponse",
  () => [
    { no: 1, name: "options", kind: "message", T: ConfigOption, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ReturnOrder
 */
export const ReturnOrder = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReturnOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "seq_no", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "customer_note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "internal_note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "resolution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "refund_amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "lines", kind: "message", T: ReturnLine, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ReturnLine
 */
export const ReturnLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReturnLine",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "return_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_line_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "condition", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateReturnRequest
 */
export const CreateReturnRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateReturnRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "resolution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "customer_note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lines", kind: "message", T: CreateReturnLineRequest, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreateReturnLineRequest
 */
export const CreateReturnLineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateReturnLineRequest",
  () => [
    { no: 1, name: "order_line_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "condition", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetReturnRequest
 */
export const GetReturnRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetReturnRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListReturnsRequest
 */
export const ListReturnsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListReturnsRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListReturnsResponse
 */
export const ListReturnsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListReturnsResponse",
  () => [
    { no: 1, name: "returns", kind: "message", T: ReturnOrder, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ApproveReturnRequest
 */
export const ApproveReturnRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveReturnRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "internal_note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "refund_amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

